// #          -> a hash
// [0-9A-F]   -> any integer from 0 to 9 and any letter from A to F
// {6}        -> the previous group appears exactly 6 times
const HEX_COLOR_REGEX = /^#[0-9A-F]{6}$/i

// Public: Returns true if the provided value is a hexadecimal color code.
export function isHexColor (value) {
  return HEX_COLOR_REGEX.test(value)
}
